import React from "react";
import { motion } from "framer-motion";

const AnimatedBtnLoader = (props) => {
  const { buttonText, disabled, type } = props;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        paddingTop: "20px",
      }}>
      <motion.button
        disabled={disabled}
        type={type}
        aria-label={disabled ? "Loading" : buttonText}
        style={{
          height: "40px",
          backgroundColor: "#1E3A5F",
          color: "white",
          fontSize: "18px",
          border: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          whiteSpace: "nowrap",
          cursor: disabled ? "not-allowed" : "pointer",
          fontFamily: "inter",
        }}
        animate={{
          width: disabled ? 50 : "100%",
          borderRadius: disabled ? 25 : 8,
        }}
        transition={{ duration: 0.5 }}>
        {disabled ? (
          <div
            style={{
              width: "20px",
              height: "20px",
              border: "3px solid white",
              borderTop: "3px solid transparent",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}></div>
        ) : (
          buttonText
        )}
      </motion.button>

      {/* Loader Animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default AnimatedBtnLoader;
